import { Component, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { Constants } from 'projects/reg-hub-client/src/constants';
import { Party, ReusableParty, OrderManagerService, ValidationService, ValidationProblem, Order, UIConfigurationService, ePartyType, Utilities } from 'reg-hub-common';
import { ReusablePartyRepositoryService, PartyRepositoryService } from 'reg-hub-common';
import { HttpParams } from '@angular/common/http';
import { StepValidationState } from 'projects/reg-hub-client/src/interfaces/step';
import { PartiesComponent } from '../parties/parties.component';
import { PartiesListComponent } from 'reg-hub-common';

@Component({
    selector: 'app-secured-parties',
    templateUrl: './secured-parties.component.html',
    styleUrls: ['./secured-parties.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SecuredPartiesComponent extends PartiesComponent {
  @ViewChild(PartiesListComponent) partiesListComponent!: PartiesListComponent;

  reusableSecuredParties: ReusableParty[] = [];

  protected businessSecuredParty = ePartyType.businessSecuredParty;
  protected individualSecuredParty = ePartyType.individualSecuredParty;

  constructor(
    private reusablePartyRepo: ReusablePartyRepositoryService,
    partyRepo: PartyRepositoryService,
    uiConfigurationService: UIConfigurationService,
    orderManager: OrderManagerService,
    validationService: ValidationService) {
    super(partyRepo, uiConfigurationService, orderManager, validationService);
  }

  protected override init(order: Order): void {
    super.init(order);

    // the order's "Request For" user group's reusables, or the corporation's when the group falls back to them
    this.reusablePartyRepo.populateScopedBaseLink(this.order.orderGroup!.corporationID, this.order.userGroupID);
    var reusablePartyParams = new HttpParams().set('isVisible', true).set('UseCorporationFallback', true)
      .set('pageSize', 100)
      .append('PartyTypeIDs', 'BusinessSecuredParty')
      .append('PartyTypeIDs', 'IndividualSecuredParty');

    this.reusablePartyRepo.getFirstPageSubscribable(reusablePartyParams).subscribe(parties => {
      this.reusableSecuredParties = parties;
    });
  }

  public override getValidationState(errors: ValidationProblem[] | undefined, order: Order): StepValidationState {
    return PartiesComponent.parseErrorsForValidationState(errors, order, Utilities.isSecuredParty);
  }

  public override getParties(): Party[] {
    const filteredSecuredParties = this.order.parties?.filter((party) => Utilities.isSecuredParty(party));
    return filteredSecuredParties ?? [];
  }

  override onSaving(): void {
    var partyToReplace = this.partiesListComponent.onSaving();
    if (partyToReplace) {
      this.replaceParty(partyToReplace!);
    }
  }
}
